import React from 'react';

const FilterIcon = ({ className }) => (
  <svg
    className={className}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 1.22222C0.5 1.03068 0.576091 0.846977 0.711534 0.711534C0.846977 0.576091 1.03068 0.5 1.22222 0.5H12.7778C12.9693 0.5 13.153 0.576091 13.2885 0.711534C13.4239 0.846977 13.5 1.03068 13.5 1.22222V3.08989C13.5 3.28142 13.4238 3.46509 13.2884 3.6005L8.65606 8.23283C8.5206 8.36824 8.44449 8.55191 8.44444 8.74344V10.6111L5.55556 13.5V8.74344C5.55551 8.55191 5.4794 8.36824 5.34394 8.23283L0.711611 3.6005C0.576159 3.46509 0.500041 3.28142 0.5 3.08989V1.22222Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FilterIcon;
